module.exports = __webpack_public_path__ + "growth_projections_2031.2ad6f9a3efed8bbbd3232bec33fff540.json";